import { z } from 'zod';
/**
 * A member, at the size everything that is *about* someone else needs them.
 *
 * Three fields, and this shape travels a lot: the faces on the hype meter, the
 * avatar sitting in a booked seat, the name on a swap offer. It lives in its
 * own module rather than inside whichever feature happened to need it first —
 * it was `hypeMemberSchema` for a while, and a seat map importing something
 * called "hype" would be the kind of small lie that survives for years.
 */
export const memberSummarySchema = z.object({
    id: z.string().uuid(),
    nickname: z.string(),
    avatarUrl: z.string().nullable(),
});
//# sourceMappingURL=members.js.map